import { render } from "./RedeemGroupButton.vue?vue&type=template&id=f1fd89e4"
import script from "./RedeemGroupButton.vue?vue&type=script&lang=js"
export * from "./RedeemGroupButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__